/**
 * dd-group-destinations-second.js — 组团游「按目的地展示」二级页交互
 *
 * 职责（轻量，无依赖，失效静默）：
 *   1. 目的地「路线图」筛选：点击目的地停靠点，即时过滤下方产品卡片（按 data-dd-gdest-dest）
 *   2. 锚点平滑滚动：Hero 按钮滚动到目的地筛选区
 */

;(function () {
  'use strict'

  var map = document.querySelector('.dd-gdest-map')
  var stops = map ? map.querySelectorAll('[data-dd-gdest]') : []
  var items = document.querySelectorAll('.dd-gdest-item')
  var countEl = document.querySelector('[data-dd-gdest-count]')

  /* ------------------------------------------------------------------------
     平滑滚动（Hero 按钮）
     ------------------------------------------------------------------------ */
  var scrollLinks = document.querySelectorAll('a[data-dd-gdest-scroll]')
  for (var i = 0; i < scrollLinks.length; i++) {
    scrollLinks[i].addEventListener('click', function (e) {
      var href = this.getAttribute('href')
      if (!href || href.charAt(0) !== '#') return
      var target = document.getElementById(href.slice(1))
      if (!target) return
      e.preventDefault()
      target.scrollIntoView({ behavior: 'smooth', block: 'start' })
      if (history.replaceState) history.replaceState(null, '', href)
    })
  }

  if (!map || !stops.length) return

  /* ------------------------------------------------------------------------
     筛选逻辑
     ------------------------------------------------------------------------ */
  function setActive(key) {
    var visible = 0

    for (var i = 0; i < stops.length; i++) {
      var active = stops[i].getAttribute('data-dd-gdest') === key
      stops[i].classList.toggle('is-active', active)
      stops[i].setAttribute('aria-pressed', active ? 'true' : 'false')
    }

    for (var j = 0; j < items.length; j++) {
      var dests = (items[j].getAttribute('data-dd-gdest-dest') || '').trim()
      var show = key === 'all' || dests.split(/\s+/).indexOf(key) !== -1
      items[j].classList.toggle('is-hidden', !show)
      if (show) visible++
    }

    if (countEl) {
      countEl.textContent = visible === 1
        ? 'Showing 1 journey'
        : 'Showing ' + visible + ' journeys'
    }
  }

  for (var i = 0; i < stops.length; i++) {
    stops[i].addEventListener('click', function () {
      setActive(this.getAttribute('data-dd-gdest'))
    })
  }
})()
